export default __webpack_public_path__ + "static/media/email.94a59c50.svg";